import Vue from 'vue'
import utils from '@/etc/utils'

Vue.filter('useFlag', function (value) {
  if (value === 'Y') return '사용'
  else if (value === 'N') return '미사용'
  else return '알수없음'
})
Vue.filter('emailFlag', function (value) {
  if (value === 'Y') return '수신'
  else if (value === 'N') return '미수신'
  else return '알수없음'
})

Vue.filter('role', function (value) {
  return utils.getLabel(value)
})

Vue.filter('roleClass', function (value) {
  if (value === 'super') return 'level--a'
  else if (value === 'admin') return 'level--b'
  else if (value === 'user') return 'level--c'
  else return ''
})

Vue.filter('order', function (value) {
  if (value === 'seq') return '최신순'
  else if (value === 'likes') return '인기순'
  else if (value === 'title') return '가나다순'
  // else if (value === 'views') return '조회순'
  else return '알수없음'
})

Vue.filter('textarea', function (value) {
  const a = value.replace('\n', '<br>')
  console.log(a)
  return a
})

// Vue.filter('label', function (value) {
//   return config.dictionary.ko.attributes[value] || value
// })

function cutByLen (str, maxByte) {
  let b = 0
  let i = 0
  while (true) {
    let c = str.charCodeAt(i)
    b += c >> 7 ? 2 : 1
    if (b > maxByte) {
      break
    }
    i++
  }
  return str.substring(0, i)
}

Vue.filter('shortenContent', function (value, max) {
  max = max || 40
  if (value && value.length && value.length > max) {
    return cutByLen(value, max) + '...'
  }
  return value
})

Vue.filter('textOnly', function (x) {
  if (x) {
    return x.toString().replace(/<(\/)?([a-zA-Z]*)(\s[a-zA-Z]*=[^>]*)?(\s)*(\/)?>/gi, ' ')
  }
  return x
})

const headers = {
  title: '제목',
  userName: '작성자',
  createdAt: '작성일',
  files: '파일',
  useFlag: '사용여부',
  views: '조회수'
}
Vue.filter('header', function (value) {
  return headers[value]
})
